<template>
  <tippy :interactive="true" placement="top" :appendTo="bodyElement">
    <span>{{ uuid.slice(0, 13) }}...</span>
    <template #content>
      <div class="tw-flex tw-items-center">
        <span class="tw-mr-2">{{ uuid }}</span>
        <t-copy-button
          class="hover:tw-bg-primary-grey-300 tw-rounded tw-shrink-0"
          :value="uuid"
          :label="t('copy')"
        />
      </div>
    </template>
  </tippy>
</template>

<script setup lang="ts">
import { Tippy } from "vue-tippy";
import TCopyButton from "@/components/TCopyButton/TCopyButton.vue";
import { useI18n } from "vue-i18n";

interface IProps {
  uuid: string;
}
defineProps<IProps>();
const { t } = useI18n();
const bodyElement = document.body;
</script>
